'use strict';

function LoanLiquidAdditionalPaymentSuccess() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this.analytics.pushEvent('virtual-page-view');
  };

  this.destroy = function () {
    this._super();
  };
}